/**
 * SCD R2 — Visuels des magasins (99 images dans /assets/magasins/).
 * visuel_[localisation]_[type]_[secteur](_[positionnement]).png — sans suffixe = cœur de gamme.
 */
const LOC_SEGMENT = { centre_ville: 'centre-ville', banlieue: 'banlieue', zone_activite: 'zone-activite' };

export const getDecorUrl = (localisationId) => {
  const seg = LOC_SEGMENT[localisationId];
  return seg ? `/assets/magasins/decor_${seg}.png` : null;
};

export const getVisuelUrl = ({ localisationId, typeId, secteurId, positionnement = 'coeur' }) => {
  const loc = LOC_SEGMENT[localisationId];
  if (!loc || !typeId || !secteurId) return null;
  // Quincaillerie : pas encore de variantes par positionnement → visuel cœur.
  const sansVariante = secteurId === 'quincaillerie';
  const suffix = !sansVariante && positionnement && positionnement !== 'coeur' ? `_${positionnement}` : '';
  return `/assets/magasins/visuel_${loc}_${typeId}_${secteurId}${suffix}.png`;
};

/* Zone d'enseigne (calque logo CSS) par type de magasin, en % de l'image. */
export const LOGO_ZONES = {
  boutique: { top: '27%', width: '15%', height: '8%' },
  moyen: { top: '25%', width: '22%', height: '8%' },
  gms: { top: '19%', width: '26%', height: '9%' },
};
